var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header_nav_contacts_row",
    transform: "translate(-335.000000, -88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "none",
    points: "-2.84217094e-14 -6.29496455e-14 375 -6.29496455e-14 375 144 -2.84217094e-14 144"
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus_icon",
    transform: "translate(335.000000, 88.000000)",
    fill: "#302745"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "11 -5.67879077e-14 11 9 20 9 20 11 11 11 11 20 9 20 9 11 3.69287934e-13 11 3.69287934e-13 9 9 9 9 -5.67879077e-14"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.ac709f10.svg";
export { ForwardRef as ReactComponent };